// extracted by mini-css-extract-plugin
export default {"card":"W6-z"};